// Модель команды или команды друзей (они одинаковы)
import TeamBaseModel from './team-base';

import teamService from '@/services/API/team/index';

import { apiService } from '@/services/APIService';

import { rHandler } from '@/plugins/RHandler';
import { TEAM_TYPES } from '@/modules/Team/constants';

import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import ClubSupervisor from './club/supervisor';
import User from '@/utils/user';
import Club from './club';

export default class Team extends TeamBaseModel {
  #user;

  constructor(team, type) {
    super(team, type);
    // team - команда пришедшая с свервера в сыром виде
    this.responseData = team;

    this.type = type;

    this.hash = team.hash || null;
    this.view_path = `/my-teams/${this.type}/${this.id}/members`;

    this.organizer = team.organizer || null;
    this.subordination_id = team.subordination_id || null;
    this.prize_places = team.prize_places || null;

    this.club = team.club ? new Club(team.club) : undefined;
    this.supervisors = (team.supervisors || []).map((i) => new ClubSupervisor(i));

    this.#user = new User();
  }

  /**
   * Доступно ли выполнение заданий или удаление участников в этой команде
   * @param userId: number - default store user
   *
   * @return result: boolean
   */
  hasAdminPermissions(userId = this.user.data.id) {
    return this.isOwner(userId) || this.isCaptain(userId);
  }

  isOwner(userId) {
    return this.owner_id === userId;
  }

  isCaptain(userId) {
    return this.captain_id === userId;
  }

  get isSupervisor() {
    return this.supervisors.map((i) => i?.user?.id).includes(this.#user?.data?.id);
  }

  get isSupervisorOwner() {
    return this.supervisors
      .filter((i) => i?.response?.is_owner)
      .map((i) => i?.user?.id)
      .includes(this.#user?.data?.id);
  }

  // NOTE (#trainer): Это юзается единожды где-то, по возможно убрать конструкцию с костылём isCaptain
  async fetchMembers() {
    if (!this.members?.length) return null;
    const response = await this.fetchMembersProfiles();
    this.members.forEach((member) => {
      member.isCaptain = this.isCaptain(member.id);
    });
    return response;
  }

  fetchJoinHash() {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.stageJoinHash,
      [TEAM_TYPES.friends]: teamService.friendsJoinHash,
      [TEAM_TYPES.coaching]: teamService.coachingJoinHash,
    };

    return rHandler(API_METHODS[this.type](this.id), (resp) => {
      this.hash = resp.data.data.hash;
    });
  }

  leave({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.leaveStageTeam,
      [TEAM_TYPES.friends]: teamService.friendsLeave,
      [TEAM_TYPES.coaching]: teamService.coachingLeave,
    };
    return rHandler(
      API_METHODS[this.type](this.id, data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  membersList({ params } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.coachingList,
      [TEAM_TYPES.friends]: teamService.coachingList,
      [TEAM_TYPES.coaching]: teamService.coachingList,
    };
    return rHandler(
      API_METHODS[this.type](this.id, params),
      (response) => {
        const items = response?.data?.data || [];
        this.members = items;
        return { response, items };
      },
      (error) => ({ error }),
    );
  }

  add({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.coachingAdd,
      [TEAM_TYPES.friends]: teamService.coachingAdd,
      [TEAM_TYPES.coaching]: teamService.coachingAdd,
    };

    return rHandler(
      API_METHODS[this.type](this.id, data),
      (response) => {
        this.members = response?.data?.data || [];
        this.members_count += Number(data?.user_ids?.length);
        return { response };
      },
      (error) => ({ error }),
    );
  }

  exclude({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.excludeEventStageMembers,
      [TEAM_TYPES.friends]: teamService.friendsExclude,
      [TEAM_TYPES.coaching]: teamService.coachingExclude,
    };

    return rHandler(
      API_METHODS[this.type](this.id, data),
      (response) => {
        this.members = response?.data?.data || [];
        this.members_count -= Number(data?.user_ids?.length);
        return { response };
      },
      (error) => ({ error }),
    );
  }

  join({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.joinByInvitionEventTeam,
      [TEAM_TYPES.friends]: teamService.friendsJoin,
      [TEAM_TYPES.coaching]: teamService.coachingJoin,
    };
    return rHandler(
      API_METHODS[this.type](data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  update(data = null) {
    return rHandler(
      apiService.put(`${this.type}/${this.id}`, data),
      (response) => ({ item: new Team(response.data.data, this.type), response }),
      (error) => ({ error }),
    );
  }

  delete() {
    return rHandler(
      apiService.delete(`${this.type}/${this.id}`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  supervisorsList({ params } = DEFAULT_PARAMS) {
    return rHandler(
      teamService.coachingSupervisorsList(this.id, params),
      (response) => {
        const items = (response?.data?.data || []).map((i) => new ClubSupervisor(i));
        return { response, items };
      },
      (error) => ({ error }),
    );
  }

  supervisorsAdd({ data } = DEFAULT_PARAMS) {
    return rHandler(
      teamService.coachingSupervisorsAdd(this.id, data),
      (response) => {
        const items = response?.data?.data || [];
        return { response, items };
      },
      (error) => ({ error }),
    );
  }

  supervisorsExclude({ data } = DEFAULT_PARAMS) {
    return rHandler(
      teamService.coachingSupervisorsExclude(this.id, data),
      (response) => {
        const items = response?.data?.data || [];
        return { response, items };
      },
      (error) => ({ error }),
    );
  }
}
